export default "__VITE_ASSET__DjO6hmAx__"